/** Guardamos bancos editables y prefijo de captura en localStorage. */

const CLAVE_COLORES = 'feria-china-2026:banco-colores'
const CLAVE_TIPOS = 'feria-china-2026:banco-tipos'
const CLAVE_ATRIBUTOS = 'feria-china-2026:banco-atributos'
const CLAVE_PREFIJO = 'feria-china-2026:prefijo-persona'

// Dejamos colores sin semilla para que el banco crezca solo con valores reales.
const COLORES_SEMILLA: string[] = []
// Estos tipos base siempre existen, pero el usuario puede agregar otros.
export const TIPOS_SEMILLA = ['Chenille', 'Velvet', 'Lino', 'Cuero']
// Arrancamos con opciones frecuentes y permitimos ampliar el banco.
const ATRIBUTOS_SEMILLA = ['Luces LED', 'Motor', 'Sonido', 'Tecnología']

function leerLista(clave: string, semilla: string[]): string[] {
  try {
    const crudo = localStorage.getItem(clave)
    return crudo ? (JSON.parse(crudo) as string[]) : semilla
  } catch {
    return semilla
  }
}

function escribirLista(clave: string, lista: string[]) {
  localStorage.setItem(clave, JSON.stringify(lista))
}

export function obtenerBancoColores(): string[] {
  return leerLista(CLAVE_COLORES, COLORES_SEMILLA)
}

export function agregarColorAlBanco(nombre: string) {
  const banco = obtenerBancoColores()
  if (!banco.includes(nombre)) escribirLista(CLAVE_COLORES, [...banco, nombre])
}

export function eliminarColorDelBanco(nombre: string) {
  escribirLista(CLAVE_COLORES, obtenerBancoColores().filter((n) => n !== nombre))
}

export function obtenerBancoTipos(): string[] {
  // Reinsertamos tipos base si un estado local antiguo no los tiene.
  const guardado = leerLista(CLAVE_TIPOS, TIPOS_SEMILLA)
  const extras = guardado.filter((n) => !TIPOS_SEMILLA.includes(n))
  return [...TIPOS_SEMILLA, ...extras]
}

export function agregarTipoAlBanco(nombre: string) {
  const banco = obtenerBancoTipos()
  if (!banco.includes(nombre)) escribirLista(CLAVE_TIPOS, [...banco, nombre])
}

export function eliminarTipoDelBanco(nombre: string) {
  // Protegemos los tipos base aunque la función se invoque directamente.
  if (TIPOS_SEMILLA.includes(nombre)) return
  escribirLista(CLAVE_TIPOS, obtenerBancoTipos().filter((n) => n !== nombre))
}

export function obtenerBancoAtributos(): string[] {
  return leerLista(CLAVE_ATRIBUTOS, ATRIBUTOS_SEMILLA)
}

export function agregarAtributoAlBanco(nombre: string) {
  const banco = obtenerBancoAtributos()
  if (!banco.includes(nombre)) escribirLista(CLAVE_ATRIBUTOS, [...banco, nombre])
}

export function eliminarAtributoDelBanco(nombre: string) {
  escribirLista(CLAVE_ATRIBUTOS, obtenerBancoAtributos().filter((n) => n !== nombre))
}

export function obtenerPrefijoPersona(): string {
  return localStorage.getItem(CLAVE_PREFIJO) ?? 'A'
}

export function guardarPrefijoPersona(letra: string) {
  localStorage.setItem(CLAVE_PREFIJO, letra)
}
